'use strict';
import React, { Component } from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import Titulo from './Titulo.jsx';
import MontoMask from "../../../../Common/Components/Mask/MontoMask.jsx"
import DateMask from "../../../../Common/Components/Mask/DateMask.jsx"

class UltimoCierre extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { proximoResumen, saldosCierre, ultimoCierre } = this.props;

        return <div>
            <Titulo
                mostrarBoton={false}
                lblBoton={"Ver Resumen"}
                titulo={"Último Cierre"}
            />


            <div className="row section-bordered">
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Fecha de Cierre:</label>
                        </div>
                        <div className="col-md-6">
                            <label className="label-primary"><DateMask fecha={ultimoCierre && ultimoCierre.FechaCierre} /></label>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Fecha de Vencimiento:</label>
                        </div>
                        <div className="col-md-6">
                            <label className="label-primary"><DateMask fecha={ultimoCierre && ultimoCierre.FechaVencimiento} /></label>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Saldo en $:</label>
                        </div>
                        <div className="col-md-6">
                            <MontoMask monto={saldosCierre && saldosCierre.SaldoCierrePesos} moneda={"pesos"} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Saldo en U$S:</label>
                        </div>
                        <div className="col-md-6">
                            <MontoMask monto={saldosCierre && saldosCierre.SaldoCierreUsd} moneda={"dolares"} />
                        </div>
                    </div>
                </div>
                <div className="col-md-6 left-separator">
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Pago Mínimo:</label>
                        </div>
                        <div className="col-md-6">
                            <MontoMask monto={ultimoCierre && ultimoCierre.PagoMinimo} moneda={"pesos"} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Forma de Pago:</label>
                        </div>
                        <div className="col-md-6">
                            {ultimoCierre != undefined ?
                                <label className="label-primary">{ultimoCierre.FormaPago}</label>
                                : <label className="label-primary"><span>-</span></label>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">Cuenta Débito $:</label>
                        </div>
                        <div className="col-md-6">
                            {ultimoCierre != undefined ?
                                ultimoCierre.CuentaDebitoEnPesos == true && proximoResumen != undefined ?
                                    <label className="label-primary"><span>{proximoResumen.CuentaBancariaNumero}</span></label>
                                    : <label className="label-primary"><span>-</span></label>
                                : <label className="label-primary"><span>-</span></label>}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="label-primary">{/*Cuenta Débito U$S:*/}</label>
                        </div>
                        <div className="col-md-6">
                            {/*<MontoMask monto={ultimoCierre && ultimoCierre.CuentaDebitoEnPesos} moneda={"dolares"} />*/}
                            <label className="label-primary">{/*-*/}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
export default UltimoCierre;